import axios from 'axios';
import { fetchOCR } from '../../api/demonstration';
import account from '@/common/account/index';

export default (requestMethod, imgurl, imgBase64) => {
  return new Promise((resolve, reject) => {
    let userId = null;
    const loginEd = account.hasLoggedin();
    if (loginEd) userId = localStorage.getItem('userId') || null;
    console.log('loginEd', loginEd, userId);
    fetchOCR({
      [requestMethod.url.key]: imgurl,
      [requestMethod.base64.key]: imgBase64,
      method: requestMethod.method,
      ...requestMethod.props,
      userId
    })
      .then((data) => {
        if (data.code === 20000 || data.code === 20001) {
          const resp = requestMethod.respProcessor(data);
          resolve(resp);
        } else {
          reject(new Error('response code is not 20000'));
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const fetchOssbase64File = (url) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      responseType: 'blob',
      url
    })
      .then((resp) => {
        const fr = new FileReader();
        fr.onload = () => {
          resolve(fr.result);
        };
        fr.readAsDataURL(resp.data);
      })
      .catch((e) => reject(e));
  });
};
